import request from '@/utils/request'

const API_GATEWAY = `https://${process.env.VUE_APP_SERVER_IP}`
const BASE_URL_APP = `${API_GATEWAY}/app` // app 模块

// 获取访客二维码数据
export function queryNewHomeVisitorInfo(id) {
  // TODO
  return request(BASE_URL_APP + `/invitation-records/${id}`, {
    method: 'GET',
  })
}
